<template>
  <footer class="footer">
    <el-divider></el-divider>
    <div class="box">
      <div class="first-line">
        <div class="el-login-footer">
          <span>© 2024 成都鑫豪斯电子探测技术有限公司 版权所有 <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备13028109号</a></span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MyFooter',
  data() {
    return {
    };
  },
};
</script>

<style scoped>
.footer {
  background: #fff;
}

.footer .box {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.footer .first-line {
  color: #666;
  font-size: 14px;
}

.footer {
  color: #999;
  font-size: 13px;
  padding-bottom: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/PC/footer/MyFooter.vue